import { AxiosResponse } from "axios";
import http from "utilities/http-common";
import { department } from "./department-service";

const baseUrl = "/api/user";

// TODO: actually at object filters instead of only pagination filters
export interface PagedUserFilter {
    page: number;
    pageSize: number;
    direction?: string;
    sortBy?: string;
    naam?: string;
    stamNummer?: string;
    pNummer?: string;
    organisatie?: string;
    referentie?: string;
    departement?: string;
    actief?: boolean[];
    statussen?: string[];
    startDatum?: Date;
    eindDatum?: Date;
    renewDatum?: Date;
    latestCertificatestatus?: string[];
}

export interface PagedUserDto {
    id: string;
    actief: boolean;
    naam: string;
    voorNaam: string;
    stamNummer: string | null;
    pNummer: string | null;
    organisatie: string | null;
    startDatum: Date | null;
    eindDatum: Date | null;
    renewDatum: Date | null;
    referentie: string | null;
    status: string | null;
    departement: string | null;
    latestCertificateId: string | null;
    multipleCertificates: boolean;
}

export interface UserDto {
    actief: boolean;
    pnummer: string;
    stamnummer: string;
    naam: string;
    voornaam: string;
    nationaliteit: string;
    rijksregisternummer: string;

    department: department | null;
    departmntId: string | null;

    latestCertificateId: string | null;
    latestCertificate: CertificateWithDetails | null;
}

export interface UserCertificateDto {
    id: string;
    referenceCode: string;
    dateFrom: Date | null;
    dateTo: Date | null;
    status: string;
}

export interface UserApplicationDto {
    id: string;
    referenceCode: string;
    dateFrom: Date | null;
    dateTo: Date | null;
    status: string;
}

export async function getPaged(
    filter: PagedUserFilter,
): Promise<PagedResponse<PagedUserDto>> {
    const url = `${baseUrl}/paged`;

    const params = new URLSearchParams();
    params.append("page", filter.page.toString());
    params.append("pageSize", filter.pageSize.toString());

    if (filter.direction) params.append("direction", filter.direction);
    if (filter.sortBy) params.append("sortBy", filter.sortBy);

    if (filter.naam) params.append("naam", filter.naam);
    if (filter.stamNummer) params.append("stamNummer", filter.stamNummer);
    if (filter.pNummer) params.append("pNummer", filter.pNummer);
    if (filter.organisatie) params.append("organisatie", filter.organisatie);
    if (filter.referentie) params.append("referentie", filter.referentie);
    if (filter.departement) params.append("departement", filter.departement);
    if (filter.startDatum)
        params.append("startDatum", filter.startDatum.toISOString());
    if (filter.eindDatum)
        params.append("eindDatum", filter.eindDatum.toISOString());
    if (filter.renewDatum)
        params.append("renewDatum", filter.renewDatum.toISOString());

    if (filter.actief !== undefined) {
        for (const actief of filter.actief) {
            params.append("actief", actief.toString());
        }
    }

    if (filter.statussen !== undefined) {
        for (const status of filter.statussen) {
            params.append("statussen", status);
        }
    }

    return http
        .get(url, { params: params })
        .then((resp: AxiosResponse<PagedResponse<PagedUserDto>>) => {
            return resp.data;
        });
}

export async function getById(id: string): Promise<UserDto> {
    const url = `${baseUrl}/${id}`;

    return http.get(url).then((resp: AxiosResponse<UserDto>) => {
        return resp.data;
    });
}

export async function setUserOutOfService(userId: string): Promise<void> {
    const url = `${baseUrl}/out-of-service/${userId}`;

    return http.post(url).then((resp: AxiosResponse<void>) => {
        return resp.data;
    });
}

export async function getUserCertificates(
    userId: string,
): Promise<UserCertificateDto[]> {
    const url = `${baseUrl}/certificates/${userId}`;

    return http.get(url).then((resp: AxiosResponse<UserCertificateDto[]>) => {
        return resp.data;
    });
}

export async function getUserApplications(
    userId: string,
): Promise<UserApplicationDto[]> {
    const url = `${baseUrl}/applications/${userId}`;

    return http.get(url).then((resp: AxiosResponse<UserApplicationDto[]>) => {
        return resp.data;
    });
}

export async function exportAllUsers(filter: PagedUserFilter): Promise<Blob> {
    const url = `${baseUrl}/export`;

    const params = new URLSearchParams();
    params.append("page", filter.page.toString());
    params.append("pageSize", filter.pageSize.toString());

    if (filter.direction) params.append("direction", filter.direction);
    if (filter.sortBy) params.append("sortBy", filter.sortBy);

    if (filter.naam) params.append("naam", filter.naam);
    if (filter.stamNummer) params.append("stamNummer", filter.stamNummer);
    if (filter.pNummer) params.append("pNummer", filter.pNummer);
    if (filter.organisatie) params.append("organisatie", filter.organisatie);
    if (filter.referentie) params.append("referentie", filter.referentie);
    if (filter.departement) params.append("departement", filter.departement);
    if (filter.startDatum)
        params.append("startDatum", filter.startDatum.toISOString());
    if (filter.eindDatum)
        params.append("eindDatum", filter.eindDatum.toISOString());
    if (filter.renewDatum)
        params.append("renewDatum", filter.renewDatum.toISOString());

    if (filter.actief !== undefined) {
        for (const actief of filter.actief) {
            params.append("actief", actief.toString());
        }
    }

    if (filter.statussen !== undefined) {
        for (const status of filter.statussen) {
            params.append("statussen", status);
        }
    }

    return http
        .get(url, { params: params, responseType: "blob" as "json" })
        .then((resp: AxiosResponse<Blob>) => {
            return resp.data;
        });
}

export interface changeDepartmentDto {
    userId: string;
    departmentName: string;
}

export async function changeDepartment(
    input: changeDepartmentDto,
): Promise<void> {
    const url = `${baseUrl}/Department/`;

    return http.put(url, input).then((resp: AxiosResponse<void>) => {
        return resp.data;
    });
}
